<template>
    <base-step-form :is-submitted="isSubmitted"
                    :is-dirty="isDirty"
                    :prefill-callback="prefillCampForm"
                    :reset-callback="resetCampForm">
        <template v-slot:step>
            <camp-registration-step></camp-registration-step>
        </template>
        <template v-slot:progress>
            <step-progress></step-progress>
        </template>
        <template v-slot:success>
            <success></success>
        </template>
    </base-step-form>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import * as Mutations from '@/store/modules/camp-form/mutations';
    import BaseStepForm from '@/components/main/pages/base/BaseStepForm';
    import { UnSavedMixin } from '@/mixins/UnSavedMixin';

    export default {
        name: 'CampForm',
        components: {
            BaseStepForm,
            Success:               () => import(/* webpackChunkName: 'camps' */ './Success'),
            CampRegistrationStep:  () => import(/* webpackChunkName: 'camps' */ './CampRegistrationStep'),
            StepProgress:          () => import(/* webpackChunkName: 'camps' */ './StepProgress')
        },
        computed: {
            ...mapGetters({
                isSubmitted: 'campCreationFormSubmitted',
                isDirty: 'campFormDirty',
                duplicate: 'duplicateCampForm'
            })
        },
        mixins: [UnSavedMixin],
        methods: {
            ...mapActions([
                'resetCampForm',
                'prefillCampForm'
            ]),

            ...mapMutations({
                duplicateForm: Mutations.CAMP_FORM_DUPLICATE_TOGGLE,
            })
        },

        beforeDestroy() {
            this.duplicate && this.duplicateForm(false);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/CampForm.vue